import { products as productApi } from '@huggg/back-bar';

// Action types
export const LOAD = 'product/LOAD';
export const LOAD_SUCCESS = 'product/LOAD_SUCCESS';
export const LOAD_FAILURE = 'product/LOAD_FAILURE';
export const LOAD_SEGMENTS = 'product/LOAD_SEGMENTS';
export const LOAD_SEGMENTS_SUCCESS = 'product/LOAD_SEGMENTS_SUCCESS';
export const LOAD_SEGMENTS_FAILURE = 'product/LOAD_SEGMENTS_FAILURE';

// Initial state
const initialState = {
  product: null,
  segments: [],
  loading: false,
  segmentsLoading: false,
  error: null,
  segmentsError: null
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { ...state, loading: true, error: null };
    case LOAD_SUCCESS:
      return { ...state, loading: false, product: action.payload.product };
    case LOAD_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case LOAD_SEGMENTS:
      return { ...state, segmentsLoading: true, segmentsError: null };
    case LOAD_SEGMENTS_SUCCESS:
      return {
        ...state,
        segmentsLoading: false,
        segments: action.payload.segments
      };
    case LOAD_SEGMENTS_FAILURE:
      return {
        ...state,
        segmentsLoading: false,
        segmentsError: action.payload.error
      };
    default:
      return state;
  }
};

export default reducer;

// Action creators (using existing back-bar SDK methods)
export const fetchProduct = productId => (dispatch, getState) => {
  dispatch({ type: LOAD });

  // Use the existing single method from back-bar SDK
  return productApi
    .single(productId)
    .then(data => {
      dispatch({ type: LOAD_SUCCESS, payload: { product: data } });
      return data;
    })
    .catch(err => {
      dispatch({ type: LOAD_FAILURE, payload: { error: err } });
    });
};

export const fetchProductSegments = productId => (dispatch, getState) => {
  dispatch({ type: LOAD_SEGMENTS });

  // Use the existing segments method from back-bar SDK
  return productApi
    .segments(productId)
    .then(data => {
      const segments = data.items || [];
      dispatch({ type: LOAD_SEGMENTS_SUCCESS, payload: { segments } });
      return segments;
    })
    .catch(err => {
      dispatch({ type: LOAD_SEGMENTS_FAILURE, payload: { error: err } });
    });
};
